module.exports = __webpack_public_path__ + "img/broken_heart.a3d99b5f.gif";